/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export interface IExampleParent {
    setExample(example : any);

    getExample() : any;
}


